<template>
  <tr class="total-summary-td" v-if="summary && visibleHeaders.length > 0">
    <td 
      v-for="(header, index) in visibleHeaders" 
      :key="header.value"
      :class="getSummaryClass(header, index)"
    >
      <template v-if="index === 0">Tổng</template>
      <template v-else-if="header.value === 'Weight'">
        {{ summary.Weight | currency('', 2) }}
      </template>
      <template v-else-if="header.value === 'Volume'">
        {{ summary.Volume | currency('', 3) }}
      </template>
      <template v-else-if="header.value === 'RealNumberOfPack'">
        {{ summary.RealNumberOfPack | currency('') }}
      </template>
      <template v-else-if="header.value === 'TotalWeight'">
        {{ summary.TotalWeight | currency('', 2) }}
      </template>
      <template v-else-if="header.value === 'TotalVolume'">
        {{ summary.TotalVolume | currency('', 3) }}
      </template>
      <template v-else-if="header.value === 'FeeShipVND'">
        {{ summary.FeeShipVND | currency('') }}
      </template>
      <template v-else-if="header.value === 'TotalAmount'">
        {{ summary.TotalAmount | currency('') }}
      </template>
      <template v-else-if="header.value === 'TotalCost'">
        {{ summary.TotalCost | currency('') }}
      </template>
      <template v-else-if="header.value === 'TotalProfit'">
        {{ summary.TotalProfit | currency('') }}
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'TransactionSummaryRow',
  props: {
    summary: {
      type: Object,
      default: () => ({})
    },
    visibleHeaders: {
      type: Array,
      required: true
    }
  },
  methods: {
    getSummaryClass(header, index) {
      const classes = [];
      if (index === 0) {
        classes.push('text-center', 'font-weight-bold');
      } else if (header.align === 'end' || header.value.includes('Price') || header.value.includes('Cost') || header.value.includes('Amount') || header.value.includes('Profit') || header.value === 'Weight' || header.value === 'Volume' || header.value === 'RealNumberOfPack' || header.value === 'TotalWeight' || header.value === 'TotalVolume' || header.value === 'FeeShipVND') {
        classes.push('text-end', 'font-weight-bold');
      }
      return classes.join(' ');
    }
  }
};
</script>
